/**
 * Védelem a regexp.test problémára.
 * Ez a függvény az eredeti regexp-ről csinál egy másolatot és azon futtatja meg a tesztet.
 * @param {RegExp} regexp - Az eredeti regexp.
 * @param {string} value - Az érték, amit vizsgálunk.
 * @returns {boolean} Megtalálható a pattern megadott értékben?
 */
module.exports.test = function test (regexp, value) {
  const newRegexp = new RegExp(regexp.source, regexp.flags)

  // eslint-disable-next-line no-restricted-syntax -- Itt használhatjuk, mert már másolat.
  return newRegexp.test(value)
}
